
import store from '@/store';
import CountryInput from '@/components/Inputs/CountryInput.vue';
import inputValidators from '@/logic/helpers/inputs/validators';
import helpers from './optimizeHelpers';
import disableDates from '@/logic/helpers/dates/disableDates';
import ServerResponseAlert from '@/components/ServerResponseAlert.vue';

export default {
  name: 'AssessorEducation',

  components: {
    CountryInput,
    ServerResponseAlert,
  },

  props: {
    noNextStep: Boolean,
    focusOnProgressCircle: Boolean,
  },

  data(): Record<string, unknown> {
    return {
      disableDates,
      educations: [],
      education: {
        name: '',
        started: '',
        ended: null,
        country: '',
        highest_degree: '',
        field_of_study: '',
      },
      educationToEditId: '',
      validationRules: {
        name: [{ validator: inputValidators.primitive, trigger: 'change' }],
        started: [{ validator: inputValidators.primitive, trigger: 'change' }],
        country: [{ validator: inputValidators.primitive, trigger: 'change' }],
      },
      processingUserDataRequest: false,
      editModeOn: false,
      serverResponse: null,
      showForm: false,
      saveAndQuit: false,
      formIsValid: false,
    };
  },

  computed: {
    educationStart(): string {
      return this.education.started;
    },
  },

  watch: {
    educations(): void {
      this.showForm = !this.educations.length;
    },

    educationStart(): void {
      this.education.ended = null;
    },
  },

  created(): void {
    this.getEducationList();
    if (!this.noNextStep) {
      this.education.country = store.state.userCountry;
    }
  },

  methods: {
    getEducationList(): void {
      helpers.getEntries(this, 'education');
    },

    addSchool(): void {
      helpers.createEntry(this, 'education');
    },

    editSchool(): void {
      helpers.updateEntry(this, 'education', this.educationToEditId);
    },

    removeSchool(id: string): void {
      helpers.deleteEntry(this, 'education', id);
    },

    turnOnTheEditMode(idx: number): void {
      helpers.turnOnTheEditMode(this, 'education', idx);
    },

    flushSchool(): void {
      helpers.purgeFormData(this, 'education');
    },
  },
};
